import { render, staticRenderFns } from "./DatabaseSimpleTable.vue?vue&type=template&id=6f082ec8"
import script from "./DatabaseSimpleTable.vue?vue&type=script&lang=js"
export * from "./DatabaseSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./DatabaseSimpleTable.vue?vue&type=style&index=0&id=6f082ec8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports